import ApiUrls from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";
import moment from 'moment';



const getRoles = () => {
    return ApiHelper.getRequest(ApiUrls.GET_ROLE);
};

const getRoleModules = (id) => {
    return ApiHelper.getRequest(ApiUrls.GET_ROLE_MODULES + id);
};

const appLogIn = (fields) => {

    var data = {
        "mobile": fields.phone,
        "countryCode": fields.countryCode

    };

    return ApiHelper.postRequest(ApiUrls.LOGIN, data);
};

const logOutUser = (sessionId) => {
    var data = {
        "sessionId": sessionId,
    };
    return ApiHelper.postRequest(ApiUrls.LOGOUT_USER, data,);
};

const confirmOTP = (newFields, otp) => {
    var data = {
        "mobile": newFields?.phone,
        "otp": otp,
        "countryCode": newFields?.countryCode
    }
    return ApiHelper.postRequest(ApiUrls.VERIFY_OTP, data,);
};

export const AuthService = {
    appLogIn,
    logOutUser,
    confirmOTP


}